import { TestableComponentProps } from '@dreryk/react-components';

import { StyledTileItemSecondaryButton } from './TileItemSecondaryButton.styled';

type TileItemSecondaryButtonProps = { onClick: VoidFunction; label: string } & TestableComponentProps;

export const TileItemSecondaryButton = (props: TileItemSecondaryButtonProps): JSX.Element => {
   return (
      <StyledTileItemSecondaryButton label={props.label} testId={props.testId} onClick={props.onClick} fullLength />
   );
};
